import { useEffect, useRef, useState } from 'react';
import { ControlBarWrapper, CustomControlButtonList, CustomControlWrapper } from '../styles';
import { VideoJsPlayer } from 'video.js';
import VastPlayControls from './VastPlayControls';
import RemindDuration from './RemindDuration';
import TitleBar from './TitleBar';
import Watermark from './Watermark';
import ControlBarVolumeController from './ControlBarVolumeController';
import { Flex } from '../../../styles';
import VastControlBarProgress from './VastControlBarProgress';

export default function PlayerVastComponents({ player, playingAd, isShort }: {
  player: VideoJsPlayer;
  playingAd: boolean;
  isShort: boolean;
}) {
  const [showPlayBtn, setShowPlayBtn] = useState<boolean>(true);
  const timer = useRef<any>();

  useEffect(() => {
    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('touchmove', handleMouseMove);
    document.addEventListener('keydown', handleMouseMove);

    return () => {
      clearTimeout(timer.current);
      timer.current = null;
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('touchmove', handleMouseMove);
      document.removeEventListener('keydown', handleMouseMove);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [player]);

  const handleMouseMove = () => {
    setShowPlayBtn(true);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      setShowPlayBtn(false);
    }, 2000);
  };

  return (
    <div style={playingAd ? { display: 'block' } : { display: 'none' }}>
      {!showPlayBtn && <Watermark />}
      <CustomControlWrapper show={true}>
        <RemindDuration player={player}/>
        <VastPlayControls player={player} showPlayBtn={showPlayBtn}/>
        {showPlayBtn && !isShort && <TitleBar />}
        <ControlBarWrapper>
          <VastControlBarProgress player={player}/>
          <CustomControlButtonList>
            <Flex>
              <ControlBarVolumeController player={player}/>
            </Flex>
          </CustomControlButtonList>
        </ControlBarWrapper>
      </CustomControlWrapper>
    </div>
  );
}
